<script setup lang="js">

import ContextWhile from "@/components/ContextWhile.vue";
import ContextTitle from "@/components/ContextTitle.vue";
import {ref} from "vue";
import CompanyTitle from "@/components/CompanyTitle.vue";
import SubButton from "@/components/SubButton.vue";
import {ElForm, ElMessage} from "element-plus";
import router from "@/router";
import axios from "axios";

const datas=ref({
  target:'',
  precedence:[],
  List:[],

})


const formRef = ref(null);
const rules = ref({
  target: [
    { required: true, message: '请选择核心目标', trigger: 'blur' },
  ],
  precedence: [
    { required: true, message: '请选择痛点优先级', trigger: 'blur' },
  ],
  population: [
    { required: true, message: '请输入辖区常住人口', trigger: 'blur' },
  ],
  service: [
    { required: true, message: '请输入就业服务站点', trigger: 'blur' },
  ],
  money: [
    { required: true, message: '请输入政资金年度预算', trigger: 'blur' },
  ],
  builder: [
    { required: true, message: '请选择建设偏好', trigger: 'blur' },
  ],
  other: [
    { required: true, message: '请输入其他', trigger: 'blur' },
  ],
  urgent: [
    { required: true, message: '请选择紧急程度', trigger: 'blur' },
  ],
  companyName: [
    { required: true, message: '请输入企业名称', trigger: 'blur' },
  ],
  userName: [
    { required: true, message: '请输入联系人', trigger: 'blur' },
  ],
  phone: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { length: 11, message: "手机号11位", trigger: 'blur' }
  ],
  email: [
    { required: true, message: '请输入邮件地址', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
  ]
});
const companyClick=()=>{
  console.log(datas.value)
  formRef.value.validate((valid) => {
    if (valid) {
      axios({
        method:"post",
        url:"http://localhost:8082/official/governmentQuestionnaire",
        headers:{tenantId:'000000'},
        data:datas.value
      }).then((res)=>{
        console.log(res)
        if (res.data.code === 200){
          ElMessage.primary('上传成功')
          router.back();
        }else {
          ElMessage.error('上传失败，请重试')
        }
      })
    } else {
      return false;
    }
  });
}
</script>

<template>
  <div>
    <context-while >
      <el-form
          ref="formRef"
          :rules="rules"
          :model="datas"
          label-width="auto"
      >
      <context-title text="政府测诊断问卷"></context-title>
      <CompanyTitle title="1.核心目标"/>
      <div>
        <el-form-item prop="target">
          <el-radio-group v-model="datas.target" class="flex flex-row">
            <el-radio value="1" size="large">降低区域失业率</el-radio>
            <el-radio value="2" size="large">建设标准化就业阵地</el-radio>
            <el-radio value="3" size="large">优化就业资金使用效能</el-radio>
            <el-radio value="4" size="large">培育特色产业人才</el-radio>
          </el-radio-group>
        </el-form-item>
        <CompanyTitle title="2.痛点优先级"/>
        <div class="lg:flex lg:text-center lg:items-center">
          <div class="mr-5 text-[1.4rem] md:text-[1.4rem]">请排序</div>
          <el-form-item prop="precedence">
            <el-checkbox-group v-model="datas.precedence">
              <el-checkbox label="数据分散难整合" value="1"/>
              <el-checkbox label="政策触达率低" value="2"/>
              <el-checkbox label="重点群体帮扶难" value="3"/>
              <el-checkbox label="产教脱节" value="4"/>
            </el-checkbox-group>
          </el-form-item>

        </div>
        <CompanyTitle title="3.基础现状"/>
        <div class="w-full lg:w-2/5 md:w-full items-center">
          <div class="w-full flex justify-between items-center text-[1.4rem] md:text-[1.4rem]">
            <div class="">辖区常住人口</div>
            <div class=" flex text-center items-center" >
              <el-form-item prop="population">
                <el-input
                    autosize
                    v-model="datas.population"
                    type="number"
                    :style="{
                  '--el-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-width': '0px',
                  '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-hover-border-width': '0px',
                }"
                    class="border-b-[1px]  border-black border-dotted"
                />
              </el-form-item>

              <text  class="w-20 md:w-20 lg:w-36">万人</text>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-2/5 md:w-full items-center">
          <div class="w-full flex justify-between items-center text-[1.4rem] md:text-[1.4rem] ">
            <div class="">现有就业服务站点</div>
            <div class=" flex text-center items-center" >
              <el-form-item prop="service">
                <el-input
                    autosize
                    v-model="datas.service"
                    type="number"
                    :style="{
                  '--el-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-width': '0px',
                  '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-hover-border-width': '0px',
                }"
                    class="border-b-[1px]  border-black border-dotted"
                />
              </el-form-item>

              <text  class="w-20 md:w-20 lg:w-36">个</text>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-2/5 md:w-full items-center">
          <div class="w-full flex justify-between items-center text-[1.4rem] md:text-[1.4rem]">
            <div class="">财政资金年度预算</div>
            <div class="flex text-center items-center" >
              <el-form-item prop="money">
                <el-input
                    autosize
                    v-model="datas.money"
                    type="number"
                    :style="{
                  '--el-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-focus-border-width': '0px',
                  '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                  '--el-input-hover-border-width': '0px',
                }"
                    class="border-b-[1px]  border-black border-dotted"
                />
              </el-form-item>

              <text class="w-20 md:w-20 lg:w-36">万元</text>
            </div>
          </div>
        </div>
        <CompanyTitle title="4.建设偏好"/>
        <el-form-item prop="builder">
          <el-checkbox-group v-model="datas.builder">
            <el-checkbox label="智慧零工社区" value="1"/>
            <el-checkbox label="社区微创园" value="2"/>
            <el-checkbox label="产教融合基地" value="3"/>
            <el-checkbox label="公共实训基地" value="4"/>
            <el-checkbox label="社区为工厂" value="5"/>
            <el-checkbox label="充分就业街区" value="6"/>
            <el-checkbox label="就业创业活动" value="7"/>
          </el-checkbox-group>
        </el-form-item>

        <div class="w-full flex items-center ">
          <div class="w-20 md:w-20 lg:w-36">其他</div>
          <div>
            <el-form-item prop="other">
              <el-input
                  autosize
                  v-model="datas.other"
                  :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                  class="border-b-[1px]  border-black border-dotted"
              />
            </el-form-item>

          </div>

        </div>

        <CompanyTitle title="5.紧急程度"/>
        <el-form-item prop="urgent">
          <el-checkbox-group v-model="datas.urgent">
            <el-checkbox label="6个月内启动" value="1"/>
            <el-checkbox label="1年规划" value="2"/>
            <el-checkbox label="政策试点申报" value="3"/>
          </el-checkbox-group>
        </el-form-item>

      </div>

      <div class="w-full bg-[#161981] h-[0.1rem] px-24"></div>
      <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
        <div class="text-2xl md:text-2xl lg:text-3xl">企业名称：</div>
        <div class="w-2/3   lg:mt-3">
          <el-form-item prop="companyName">
            <el-input
                autosize
                v-model="datas.companyName"
                type="textarea"
                :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                class="border-b-[1px]  border-black w-full"
            />
          </el-form-item>

        </div>
      </div>
      <div class="lg:flex lg:justify-between">
        <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
          <div class="text-2xl md:text-2xl lg:text-3xl">联系人：</div>
          <div class="w-2/3   lg:mt-3">
            <el-form-item prop="userName">
              <el-input
                  autosize
                  type="textarea"
                  v-model="datas.userName"
                  :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                  class="border-b-[1px]  border-black w-full"
              />
            </el-form-item>

          </div>
        </div>

        <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
          <div class="text-2xl md:text-2xl lg:text-3xl">联系电话：</div>
          <div class="w-2/3   lg:mt-3">
            <el-form-item prop="phone">
              <el-input
                  autosize
                  v-model="datas.phone"
                  type="textarea"
                  :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                  class="border-b-[1px]  border-black w-full"
              />
            </el-form-item>

          </div>
        </div>




      </div>


      <div class="w-full flex items-center  mt-3 md:mt-3 lg:mt-5">
        <div class="text-2xl md:text-2xl lg:text-3xl">邮件地址：</div>
        <div class="w-2/3 lg:mt-3">
          <el-form-item prop="email">
            <el-input
                autosize
                type="textarea"
                v-model="datas.email"
                :style="{
                '--el-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-focus-border-width': '0px',
                '--el-input-hover-border-color': 'rgba(255,255,255,0.0)',
                '--el-input-hover-border-width': '0px',
              }"
                class="border-b-[1px]  border-black w-full"
            />
          </el-form-item>

        </div>
      </div>
      <sub-button @click="companyClick"></sub-button>
      </el-form>
    </context-while>

  </div>
</template>

<style scoped>
</style>
